import * as v from "valibot";

import { rpcContract } from "../rpc";

export const contentThemeSchema = v.object({
  id: v.string(),
  name: v.string(),
  created: v.string(),
  last_updated: v.string(),
});

export const contentThemeResultSchema = v.object({
  categories: v.array(contentThemeSchema),
});

export type ContentTheme = v.InferOutput<typeof contentThemeSchema>;
export type ContentThemesResult = v.InferOutput<typeof contentThemeResultSchema>;

export const contentThemesRpcContract = rpcContract({
  paramsSchema: v.object({}), // No parameters needed - just fetch all categories
  resultSchema: contentThemeResultSchema,
  name: "content-themes",
});

export type ContentThemesParams = v.InferOutput<(typeof contentThemesRpcContract)["paramsSchema"]>;
